// extracted by mini-css-extract-plugin
export default {"title":"Section2_title__ulZEn"};